
export default {
  name: 'DaisoStaticImage',
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    imageClass: {
      type: String,
      default: ''
    },
    priority: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isErrorHandled: false,
      noImagePath: '/images/tempLy/noimage.png',
      currentSrc: null
    }
  },
  computed: {
    processedSrc () {
      if (!this.src) {
        return this.fallbackSrc
      }
      if (this.isErrorHandled) {
        return this.fallbackSrc
      }
      return this.src
    },
    fallbackSrc () {
      return this.error || this.noImagePath
    }
  },
  watch: {
    src: {
      immediate: true,
      handler () {
        this.isErrorHandled = false
        this.currentSrc = this.processedSrc
      }
    }
  },
  methods: {
    load () {
      this.$emit('load')
    },
    errorImage () {
      if (!this.isErrorHandled) {
        this.isErrorHandled = true
        this.currentSrc = this.fallbackSrc
        this.$emit('error')
      }
    }
  }
}
